export enum SystemRoles {
    SuperAdmin= 'SuperAdmin',
}
